module.exports = __webpack_public_path__ + "static/feature-4-9a4f99b8c26cc652887654cd5ed88c65.svg";